import { ContractInfoResponse } from '@/types/api/mypage/contractInfo';
import api from '@/utils/api';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { insertServiceIdInApiUrlSync } from '@/utils/common';
import { ApiUrl } from '@/utils/constants';
import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import useInsertServiceIdInApiUrl from '../useInsertServiceIdInApiUrl';

/** 契約者情報取得APIのURL */
const apiUrl = ApiUrl.Read.CONTRACT_INFO_V2;

/**
 * 契約者情報取得APIの呼び出しフック
 * SigV4署名付きGETリクエストで契約者情報（氏名・住所・連絡先等）を取得する。
 *
 * @returns execute - API実行関数。serviceIdを引数に渡すとURLパラメータに埋め込む
 */
const useGetContractInfo = () => {
  const { insertServiceIdInApiUrl } = useInsertServiceIdInApiUrl();

  const execute = useCallback(
    /**
     * @param serviceId ログイン時など、非同期のためにuseInsertServiceIdInApiUrlでの変換時にserviceIdの取得が間に合わない場合に指定する
     */
    async (serviceId?: string): Promise<AxiosResponse<ContractInfoResponse>> => {
      let apiUrlWithServiceId = insertServiceIdInApiUrl(apiUrl);
      if (serviceId) {
        // ログイン直後など同期的にserviceIdが必要な経路では明示指定を優先する。
        apiUrlWithServiceId = insertServiceIdInApiUrlSync(apiUrl, serviceId);
      }
      const headers = await getSigV4HeadersForGet(apiUrlWithServiceId);
      return api.get(apiUrlWithServiceId, headers);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return { execute };
};

export default useGetContractInfo;
